import { render, staticRenderFns } from "./MenuReportDelivery.vue?vue&type=template&id=620e9714&"
import script from "./MenuReportDelivery.vue?vue&type=script&lang=js&"
export * from "./MenuReportDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports